import { Injectable } from '@angular/core';
import { AppContext, FrameContext } from '@farris/devkit';
import { of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';

/**
 * ç»æè¡¨åç¼è¾ç¶ææå¡
 */
@Injectable()
class EndEditService {
  constructor(private frameContext: FrameContext) {
  }
  /**
   * ç»æç¼è¾
   */
  public endEdit() {
    const appContext: AppContext = this.frameContext && this.frameContext.getFormAppContext();
    return of(null).pipe(
      tap(() => {
        if (appContext) {
          appContext.messagePipe.next({ type: 'endEdit' });
        }
      }),
      // todo: ä¸åºè¯¥ä½¿ç¨delayï¼åºè¯¥ä¸²æµ
      delay(120)
    );
  }
}
export { EndEditService };
